module.exports = __webpack_public_path__ + "static/media/rj-todos.262a9be8.png";